import React, { useState } from 'react';
import { Navigate, Outlet, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from './Sidebar';
import { Bars3Icon } from '@heroicons/react/24/outline';

const ClientLayout = () => {
  const { user, loading } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  if (loading) return null;
  
  if (!user) return <Navigate to="/login" replace />;
  
  // If user is pro, they SHOULD NOT be here
  if (user.role === 'pro') return <Navigate to="/pro/dashboard" replace />;

  return (
    <div className="flex flex-col lg:flex-row min-h-screen bg-reglow-bg overflow-hidden font-sans">
      <Sidebar role="client" isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
      
      {/* Mobile Top Bar */}
      <header className="lg:hidden flex items-center justify-between p-4 bg-white border-b border-gray-100 shadow-sm z-30">
        <div className="flex items-center gap-3">
          <button 
            onClick={() => setIsMobileMenuOpen(true)}
            className="p-2 -ml-2 text-gray-500 hover:bg-gray-50 rounded-xl"
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
          <Link to="/" className="text-xl font-bold text-gray-900 tracking-tighter flex items-center gap-1">
            Re-Glow<span className="text-reglow-primary">.</span>
          </Link>
        </div>
      </header>

      <main className="flex-1 overflow-y-auto w-full lg:min-w-0">
        <div className="relative z-10 mx-auto w-full">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default ClientLayout;
